<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Set a new password"
        key="customerPortal.kc.set-password.title"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-lg md:text-xl"
    >
      <T
        str="Set a password for your new account."
        key="customerPortal.kc.set-password.subtitle"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
  </div>
  <form
    class="flex flex-col gap-6 revolution-form"
    #registerBusinessInviteForm
    [formGroup]="form"
    method="POST"
    [action]="viewData.registrationAction"
    (ngSubmit)="set()"
  >
    <div class="w-full lg:w-1/2 flex flex-col gap-3">
      <mat-form-field class="email">
        <mat-label>
          {{ 'email' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="email"
          name="username"
        />
        <mat-icon
          *ngIf="form.controls.email.touched && form.controls.email.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.email.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.email,
              'customerPortal.kc.register.email.error.',
              {
                errKey: {
                  pattern: 'enter-valid-email',
                  email: 'enter-valid-email',
                  maxlength: 'maximum-length-exceeded'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="password">
        <mat-label>
          <T
            str="Set a new password"
            key="customerPortal.kc.set-password.password"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="vpn"></mat-icon>
        <input
          class="input"
          matInput
          type="password"
          required
          formControlName="password"
          name="password"
        />
        <mat-icon
          *ngIf="
            form.controls.password.touched && form.controls.password.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.password.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.password,
              'customerPortal.kc.register.password.error.',
              {
                num: 8,
                errKey: {
                  length: 'min-password-length',
                  minlength: 'min-password-length',
                  lowercase: 'password-lowercase-required',
                  uppercase: 'password-uppercase-required',
                  numeric: 'password-number-required',
                  invalid: 'password-invalid'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="password-confirm">
        <mat-label>
          <T
            str="Passowrd confirm"
            key="customerPortal.kc.set-password.password-confirm"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="vpn"></mat-icon>
        <input
          class="input"
          matInput
          type="password"
          required
          formControlName="passwordConfirm"
          name="password-confirm"
        />
        <mat-icon
          *ngIf="
            form.controls.passwordConfirm.touched &&
            form.controls.passwordConfirm.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.passwordConfirm.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.passwordConfirm,
              'customerPortal.kc.register.password-confirm.error.',
              {
                num: 8,
                errKey: {
                  length: 'min-password-length',
                  minlength: 'min-password-length',
                  lowercase: 'password-lowercase-required',
                  uppercase: 'password-uppercase-required',
                  numeric: 'password-number-required',
                  invalid: 'password-invalid'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="grid gap-2.5">
      <div class="flex items-center gap-2.5">
        <mat-checkbox
          color="primary"
          required
          formControlName="accept"
        ></mat-checkbox>
        <!-- prettier-ignore -->
        <p
          class="font-efSans text-sm text-mat-ef-revolution-primary-500 a-link"
          [innerHTML]="getTranslation1()"
        ></p>
      </div>
      <mat-error
        *ngIf="form.controls.accept.dirty && form.controls.accept.invalid"
      >
        <T
          str="You must accept the terms before proceeding"
          key="customerPortal.kc.set-password.accept.error"
          tags="kc-forms, 3.1"
        >
        </T>
      </mat-error>
      <div class="flex items-center gap-2.5">
        <mat-checkbox
          color="primary"
          required
          formControlName="accept2"
        ></mat-checkbox>
        <!-- prettier-ignore -->
        <p
          class="font-efSans text-sm text-mat-ef-revolution-primary-500 a-link"
          [innerHTML]="getTranslation2()"
        ></p>
      </div>
      <mat-error
        *ngIf="form.controls.accept2.dirty && form.controls.accept2.invalid"
      >
        <T
          str="You must accept the terms before proceeding"
          key="customerPortal.kc.set-password.accept.error"
          tags="kc-forms, 3.1"
        >
        </T>
      </mat-error>
    </div>
    <div class="w-full md:w-1/2">
      <button
        mat-button
        mat-flat-button
        color="secondary"
        type="submit"
        class="w-full py-2 revolution button-spinner"
        [disabled]="!form.valid || submitting"
      >
        <customer-portal-ef-spinner
          [color]="'mat-ef-revolution-grey-two-500'"
          [opacity]="0.7"
          [diameter]="16"
          *ngIf="submitting"
        >
        </customer-portal-ef-spinner>
        <T
          str="create Account"
          key="customerPortal.kc.set-password.button"
          tags="kc-forms, 3.1"
        >
        </T>
      </button>
    </div>
  </form>
</div>
